import { FC } from "react";
import { Source, Layer } from "react-map-gl/mapbox";
import { BoundaryPoint } from "../../types";

interface BoundaryPolygonProps {
  boundaryPoints: BoundaryPoint[];
  isBoundaryMode: boolean;
}

export const BoundaryPolygon: FC<BoundaryPolygonProps> = ({
  boundaryPoints,
  isBoundaryMode,
}) => {
  // console.log("BOUNDARIES [BoundaryPolygons.tsx]: ", boundaryPoints);

  if (boundaryPoints.length < 3) return null;

  const polygonData = {
    type: "Feature" as const,
    properties: {},
    geometry: {
      type: "Polygon" as const,
      coordinates: [
        [
          ...boundaryPoints.map((point) => [
            point.coordinates.longitude,
            point.coordinates.latitude,
          ]),
          [
            boundaryPoints[0].coordinates.longitude,
            boundaryPoints[0].coordinates.latitude,
          ],
        ],
      ],
    },
  };

  const lineData = {
    type: "Feature" as const,
    properties: {},
    geometry: {
      type: "LineString" as const,
      coordinates: boundaryPoints.map((point) => [
        point.coordinates.longitude,
        point.coordinates.latitude,
      ]),
    },
  };

  return (
    <>
      {/* Boundary Polygon */}
      <Source id="boundary-polygon" type="geojson" data={polygonData}>
        <Layer
          id="boundary-fill"
          type="fill"
          paint={{
            "fill-color": "red",
            "fill-opacity": isBoundaryMode ? 0.4 : 0.15,
          }}
        />
        <Layer
          id="boundary-outline"
          type="line"
          paint={{
            "line-color": "red",
            "line-width": isBoundaryMode ? 4 : 3,
            "line-opacity": 0.8,
          }}
        />
      </Source>

      {/* Boundary Lines (for 2+ points) */}
      {boundaryPoints.length >= 2 && (
        <Source id="boundary-lines" type="geojson" data={lineData}>
          <Layer
            id="boundary-line"
            type="line"
            paint={{
              "line-color": "red",
              "line-width": isBoundaryMode ? 4 : 3,
              "line-opacity": 0.8,
              "line-dasharray": isBoundaryMode ? [0] : [2, 2],
            }}
          />
        </Source>
      )}
    </>
  );
};
